import { devices } from '@evidia/components';
import styled from 'styled-components';

export const Card = styled.div`
	box-shadow: 0px 1px 3px 0px #0000001a;
	padding: 4px 16px;
	width: 500px;
	border-radius: 6px;

	@media ${devices.mobileL} {
		width: 100%;
	}
`;

export const CardButton = styled.button`
	width: 100%;
	text-align: left;
	padding: 10px 16px;
	border: none;
	border-bottom: 1px solid #0000001a;
	background-color: transparent;
	outline: none;

	font-size: 16px;
	font-family: 'Inter';

	cursor: pointer;

	.ant-spin {
		padding-right: 10px;
	}

	&:last-of-type {
		border-bottom: none;
	}
`;
